import { render, staticRenderFns } from "./Content_review.vue?vue&type=template&id=03820b43"
import script from "./Content_review.vue?vue&type=script&lang=js"
export * from "./Content_review.vue?vue&type=script&lang=js"
import style0 from "./Content_review.vue?vue&type=style&index=0&id=03820b43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports